class CreditCard {
  public readonly id: string;
  public readonly last4Digits: string;
  public readonly expirationYear: number;
  public readonly expirationMonth: number;
  public readonly type: string;
  constructor({
    id,
    last4Digits,
    expirationYear,
    expirationMonth,
    type,
  }: {
    id: string;
    last4Digits: string;
    expirationYear: number;
    expirationMonth: number;
    type: string;
  }) {
    this.id = id;
    this.last4Digits = last4Digits;
    this.expirationYear = expirationYear;
    this.expirationMonth = expirationMonth;
    this.type = type;
  }

  public static fromJSON = (value: any) => {
    const { id, last_4_digits, expiration_year, expiration_month, type } = Object.assign({}, value);
    const last4Digits = last_4_digits;
    const expirationYear = expiration_year;
    const expirationMonth = expiration_month;

    if (typeof id !== 'number') throw new TypeError('.id must be a number');
    if (typeof last4Digits !== 'string') throw new TypeError('.last4Digits must be a string');
    if (typeof expirationYear !== 'number') throw new TypeError('expirationYear must be a number');
    if (typeof expirationMonth !== 'number') throw new TypeError('expirationMonth must be a number');
    if (typeof type !== 'string') throw new TypeError('.type must be a string');

    return new CreditCard({
      id: String(id),
      last4Digits,
      expirationYear,
      expirationMonth,
      type,
    });
  };
}

export default CreditCard;
